














import {
  Component, Vue, Prop,
} from 'vue-property-decorator';

@Component
export default class BaseTabs extends Vue {
  @Prop({
    type: Array,
    default: () => [],
  }) tabs!: any

  @Prop({
    type: Number,
    default: 0,
  }) activeIndex!: number

  // @Emit('updateSubject')
  handleClick(id: number) {
    this.$emit('updateSubject', id);
  }
}
